import { createContext } from "react";
import { SearchContextDefaultData } from "./SearchContextDefaultData";

export const SearchContext = createContext(SearchContextDefaultData);
